// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uNj0","label":"styles_label__2T3mu"};